import React, { ReactNode, MouseEvent } from 'react';
import { Translate } from 'react-redux-i18n';
import Loader from '../Loader';

type Props = {
  type: 'primary' | 'secondary' | 'third' | 'fourth' | 'fifth' | 'back',
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void,
  i18nKey?: string,
  children?: ReactNode,
  buttonType?: 'button' | 'submit' | 'reset',
  className?: string,
  i18nValue?: { [key: string]: string },
  selected?: boolean,
  disabled?: boolean,
  buttonRef?: React.RefObject<HTMLButtonElement>,
  isLoading?: boolean,
};

type State = {
};

class Button extends React.Component<Props, State> {
  static defaultProps = {
    buttonType: 'button',
    i18nValue: {},
    disabled: false,
  };

  state = {};

  render(): ReactNode {
    return (
      /* eslint-disable react/button-has-type */
      <button
        ref={this.props.buttonRef}
        disabled={this.props.disabled}
        type={this.props.buttonType}
        className={`button ${this.props.type} ${this.props.className || ''} ${this.props.selected ? 'selected' : ''} ${this.props.disabled ? 'disabled' : ''}`}
        onClick={this.props.onClick}
      >
        {
          !this.props.isLoading
          && this.props.i18nKey && (
            <Translate value={this.props.i18nKey} {...this.props.i18nValue} />
          )
        }
        {
          this.props.isLoading
          && (
            <Loader />
          )
        }
        {
          this.props.children
        }
      </button>
    );
  }
}

export default Button;
